var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6028 7.4255C17.4867 2.96791 14.2881 0.724609 10.0001 0.724609C5.70995 0.724609 2.51352 2.96791 0.39745 7.42773C0.312574 7.60746 0.268555 7.80375 0.268555 8.00251C0.268555 8.20127 0.312574 8.39756 0.39745 8.57729C2.51352 13.0349 5.71218 15.2782 10.0001 15.2782C14.2903 15.2782 17.4867 13.0349 19.6028 8.57506C19.7747 8.21345 19.7747 7.79381 19.6028 7.4255ZM10.0001 13.671C6.39968 13.671 3.76352 11.8451 1.90415 8.0014C3.76352 4.15765 6.39968 2.33175 10.0001 2.33175C13.6006 2.33175 16.2367 4.15765 18.0961 8.0014C16.239 11.8451 13.6028 13.671 10.0001 13.671ZM9.91084 4.07282C7.7412 4.07282 5.98227 5.83175 5.98227 8.0014C5.98227 10.171 7.7412 11.93 9.91084 11.93C12.0805 11.93 13.8394 10.171 13.8394 8.0014C13.8394 5.83175 12.0805 4.07282 9.91084 4.07282ZM9.91084 10.5014C8.52915 10.5014 7.41084 9.38309 7.41084 8.0014C7.41084 6.6197 8.52915 5.5014 9.91084 5.5014C11.2925 5.5014 12.4108 6.6197 12.4108 8.0014C12.4108 9.38309 11.2925 10.5014 9.91084 10.5014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.0ddb4f3d8498ac439273cb67022acf25.svg";
export { ForwardRef as ReactComponent };